"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var ExpansionPanel_1 = __importDefault(require("./ExpansionPanel"));
var ExpansionPanelGroup = function (props) {
    var accordion = props.accordion, children = props.children, classes = props.classes, offset = props.offset, whiteOnWhite = props.whiteOnWhite, otherProps = __rest(props, ["accordion", "children", "classes", "offset", "whiteOnWhite"]);
    var _a = react_1.useState(), active = _a[0], setActive = _a[1];
    react_1.useEffect(function () {
        var childArray = react_1.default.Children.toArray(children);
        var openEPs = childArray.map(function (ep, index) {
            return [index, ep.props.open === true];
        }).filter(function (t) { return t[1] === true; });
        if (openEPs.length !== 0) {
            setActive(openEPs[0][0]);
        }
    }, [accordion, children]);
    return (react_1.default.createElement("div", __assign({}, otherProps, { className: getClasses(offset, whiteOnWhite, classes) }),
        accordion && react_1.default.Children.map(children, function (child, i) {
            if (child.type === ExpansionPanel_1.default) {
                return react_1.default.cloneElement(child, {
                    onClick: function (open, index) {
                        var onClick = child.props.onClick;
                        setActive(index);
                        typeof onClick === 'function' && onClick(open, index);
                    },
                    open: i === active,
                    key: i,
                    index: i
                });
            }
            return null;
        }),
        !accordion && children));
};
ExpansionPanelGroup.defaultProps = {
    offset: true
};
var getClasses = function (offset, whiteOnWhite, classes) {
    return classnames_1.default('fds-expansion-panel-group', {
        'fds-expansion-panel-group-no-offset': !offset,
        'fds-white-on-white': whiteOnWhite
    }, classes);
};
exports.default = ExpansionPanelGroup;
